function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_367_11923)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.50954 6.43389C5.06218 6.43389 6.32084 5.17522 6.32084 3.62258C6.32084 2.06994 5.06218 0.811279 3.50954 0.811279C1.9569 0.811279 0.698242 2.06994 0.698242 3.62258C0.698242 5.17522 1.9569 6.43389 3.50954 6.43389Z",
  fill: "#00B4AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.3456 9.24512C18.7978 9.24512 17.5343 10.5086 17.5343 12.0564C17.5343 15.152 15.0073 17.679 11.9117 17.679C8.81612 17.679 6.28911 15.152 6.28911 12.0564C6.28911 10.5086 5.0256 9.24512 3.4778 9.24512C1.93001 9.24512 0.666504 10.5086 0.666504 12.0564C0.666504 18.2476 5.68895 23.3016 11.9117 23.3016C18.1029 23.3016 23.1569 18.2792 23.1569 12.0564C23.1569 10.477 21.8934 9.24512 20.3456 9.24512Z",
  fill: "#00B4AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.3455 6.43389C21.8981 6.43389 23.1568 5.17522 23.1568 3.62258C23.1568 2.06994 21.8981 0.811279 20.3455 0.811279C18.7928 0.811279 17.5342 2.06994 17.5342 3.62258C17.5342 5.17522 18.7928 6.43389 20.3455 6.43389Z",
  fill: "#00B4AA"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_367_11923"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));
var SvgLogoMobiauto = function SvgLogoMobiauto(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoMobiauto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-mobiauto.8ddcd1e9.svg";
export { ForwardRef as ReactComponent };